module.exports = __webpack_public_path__ + "img/apple-pay.0247269b.svg";